module.exports = {"baseQuery":"","defaultSort":[{"id":"ModifiedOnDateTime","desc":true}],"ignoreFields":["GDB_FROM_DATE","GDB_TO_DATE","GDB_ARCHIVE_OID"]}


//////////////////
// WEBPACK FOOTER
// ./src/defaults/datagrids/incidentHistory.json
// module id = 699
// module chunks = 0